import { AdminListCard } from "@components/CatalogIndex";

// Shown to someone who can't see change orders but could grant themselves
// the privilege (the flag is on and they manage roles).
const RolesHint = () => (
  <AdminListCard title="Change Orders">
    <p className="p-3 mb-0">
      Change orders are off for your role. Grant the <em>Change Orders</em>{" "}
      privilege in <a href="/admin/roles">Settings → Roles</a>.
    </p>
  </AdminListCard>
);

export default RolesHint;
